import * as React from 'react';

import {
  RangeSliderContainer,
  RangeSliderInput,
  RangeSliderStepIndicator,
} from './styled';

export const RangeSlider: React.FC<RangeSliderProps> = ({
  min,
  max,
  answer,
  onChange,
  step,
  steps,
  isDeprecationSlider,
}) => {
  const calculateBackgroundValue = () => {
    const range = parseInt(max) - parseInt(min);
    const multiplier = parseInt(answer) - parseInt(min);
    return (100 / range) * multiplier;
  };

  const calculateOffsetLeft = (index: number) => {
    if (isDeprecationSlider) {
      return index * (10 / 9) * 10;
    }
    return index * Number(step);
  };

  return (
    <RangeSliderContainer>
      {steps &&
        Array(steps)
          .fill(null)
          .map((stepItem, index) => {
            const passedStepIndicator =
              (index + 1) * Number(step) <= Number(answer);
            return (
              <RangeSliderStepIndicator
                key={index}
                $passedStepIndicator={passedStepIndicator}
                $isActive={
                  isDeprecationSlider
                    ? (index + 1) * Number(step) === Number(answer)
                    : calculateOffsetLeft(index) === Number(answer)
                }
                $offsetLeft={
                  index + 1 === steps
                    ? `calc(${calculateOffsetLeft(index)}% - 12px)`
                    : `${calculateOffsetLeft(index)}%`
                }
              />
            );
          })}
      <RangeSliderInput
        type="range"
        min={min}
        max={max}
        step={step}
        value={answer}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        backgroundValue={calculateBackgroundValue()}
      />
    </RangeSliderContainer>
  );
};

type RangeSliderProps = {
  min: string;
  max: string;
  answer: string;
  step?: string;
  steps?: number;
  onChange: (value: string) => void;
  withStepsIndicators?: boolean;
  isDeprecationSlider?: boolean;
};
